module.exports = __webpack_public_path__ + "img/product1.18830c5.webp";